export default __webpack_public_path__ + "static/thermana1-2ff65606688a160fe98f8c11320dab88.jpg";